import {Column, Form} from '../../../../../stores/Form';
import {fetchFirstPage, fetchLastPage, requestPaginationData} from '../../../actions/pagination';
import {PAGE_LIMIT} from '../../../consts/pagination';
import {NavParams} from '../../Table/types/NavParams';

export const getNextCellIndex = (
    currentCellIndex: number,
    columns: Column[],
    skipDisabled = false
) => {
    const nextColumn =
        currentCellIndex < columns.length - 1 ? columns[currentCellIndex + 1] : columns[0];
    if (skipDisabled && nextColumn.isReadonly) {
        return getNextCellIndex(nextColumn.index, columns, skipDisabled);
    }

    return nextColumn.index;
};

export const getPrevCellIndex = (
    currentCellIndex: number,
    columns: Column[],
    skipDisabled = false
) => {
    const nextColumn =
        currentCellIndex > 0 ? columns[currentCellIndex - 1] : columns[columns.length - 1];

    if (skipDisabled && nextColumn.isReadonly) {
        return getPrevCellIndex(nextColumn.index, columns, skipDisabled);
    }
    return nextColumn.index;
};

export const navigateToNextCell = (data: NavParams) => {
    const {columns, currentCellIndex, rowsCount, currentRow, setFocusCell} = data;
    const nextCellIndex = getNextCellIndex(currentCellIndex, columns, true);
    let rowIndex = nextCellIndex === 0 ? currentRow + 1 : currentRow;

    if (rowIndex >= rowsCount) {
        rowIndex = rowsCount - 1;
    }

    setFocusCell(nextCellIndex, rowIndex);
};

export enum NavDirection {
    prev = 'prev',
    next = 'next'
}

export const shouldChangePage = (
    form: Form,
    currentRow: number,
    direction: NavDirection
): boolean => {
    const {hasMore, paginationOffset} = form;
    const hasPages = hasMore || paginationOffset > 0;

    if (direction === NavDirection.next) {
        return hasPages && currentRow === form.records.length - 1;
    } else {
        return hasPages && currentRow === 0;
    }
};

export const calculateFocusRowIndex = (form: Form, direction: NavDirection): number => {
    const {allRecordsCount, paginationOffset} = form;

    if (direction === NavDirection.prev) {
        return paginationOffset === 0 ? (allRecordsCount % PAGE_LIMIT) - 1 : PAGE_LIMIT - 1;
    } else {
        return 0;
    }
};

export const changePaginationPage = async (
    form: Form,
    direction: NavDirection,
    focusRowIndex?: number
): Promise<void> => {
    const {paginationOffset, allRecordsCount, hasMore} = form;

    if (direction === NavDirection.prev) {
        if (paginationOffset === 0) {
            const focusRow = focusRowIndex ?? calculateFocusRowIndex(form, NavDirection.prev);
            await fetchLastPage(form, focusRow);
        } else {
            const offset = paginationOffset - PAGE_LIMIT;
            const focusRow = focusRowIndex ?? PAGE_LIMIT - 1;
            await requestPaginationData(form, PAGE_LIMIT, offset, focusRow, true);
        }
    } else {
        if (allRecordsCount === form.currentRow + paginationOffset + 1) {
            await fetchFirstPage(form, 0);
        } else {
            const offset = hasMore ? paginationOffset + PAGE_LIMIT : 0;
            await requestPaginationData(form, PAGE_LIMIT, offset, 0, true);
        }
    }
};
